import { type FC } from "react";

import { useTranslations } from "@jti/ui";

import styles from "./CartPageHeader.module.scss";

type CartPageHeaderProps = { subtitle?: string };

export const CartPageHeader: FC<CartPageHeaderProps> = ({ subtitle }) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.container} data-testid="cart-page-header">
      <div className={styles.title} data-testid={"cart-page-header-title"}>
        {__("cart.title.cart")}
      </div>
      {subtitle && (
        <span className={styles.subtitle} data-testid="cart-page-header-subtitle">
          {subtitle}
        </span>
      )}
    </div>
  );
};
